import React from 'react'
import { AppBar } from '@mui/material'

const Footer = () => {
  return (
    <AppBar color='#302E2EFF' position='static' sx={{ textAlign: 'center', bgcolor: '#302E2EFF' }}>
      {/* <h6>&copy; Copyright eBank-Lite 2025</h6> */}
      <h6 style={{ color: 'white' }}>&copy; MJA Motors 2025</h6>
    </AppBar>
  )
}

export default Footer
